import React from 'react';
import {getBanPaymentMethodDisplayParts} from '../Constants/banPaymentDataTypeEnum';
import {BanPaymentDataType} from '../Constants/banPaymentDataTypeEnum';

/**
 * Shared payment-method line for update-payment ban lists (select step, details popup).
 * @param {'inline'|'split'} layout - inline: single line; split: label + masked (Figma details popup).
 */
const UpdatePaymentBanPaymentInfo = ({ban, block, layout = 'inline', size}) => {
  const info = () => {
    if (
      ban.paymentData?.paymentType == BanPaymentDataType.DIFFERENT ||
      ban.paymentData?.paymentType == BanPaymentDataType.UNKNOW ||
      ban.hasPaymentMethodIssue
    ) {
      return 'ללא אמצעי תשלום';
    }
    return getBanPaymentMethodDisplayParts(ban.paymentData);
  };
  if (!info()) {
    return null;
  }

  let paymentClass = `${block}__payment${size === 'small' ? ' s-title-small' : ''}`;
  if (ban.hasPaymentMethodIssue) {
    paymentClass = `${paymentClass} ${block}__payment--issue`;
  }

  return <div className={paymentClass}>{info()}</div>;
};

export default UpdatePaymentBanPaymentInfo;
